//编辑头像像素大小
export const SMALL_IMG_WIDTH = 160
export const LARGE_IMG_WIDTH = 200
// 派生自零依赖共享源 constant/prefetch-home-image.ts（SW 图片预取与页面同吃一份宽度，
// 不一致会导致预取 URL 与页面 img src 不同 → 缓存不命中）。改值请改共享源。
export { HOME_CARD_IMAGE_WIDTH as DEFAULT_CHARACTER_LIST_IMAGE_WIDTH } from './prefetch-home-image'
//创建角色用户上传图片限制
export const MAX_USER_UPLOAD_IMG_SIZE = 20 * 1024 * 1024
export const MAX_USER_UPLOAD_ANIMATED_SIZE = 20 * 1024 * 1024
export const MAX_UPLOAD_IMG_SIZE = 500 * 1024
export const MAX_GENERATE_IMG_SIZE = 250 * 1024
